<template>
  <v-row justify="center">
    <v-dialog v-model="infoDialog" persistent :max-width="dialogWidth">
      <v-card justify="center">
        <v-card-title class="subtitle-1 light-green lighten-3">{{ dialogTitle }}</v-card-title>
        <br/>
        <v-row style="width: 100%;">
          <v-col md="12" align="left">
            <div style="margin-left: 10%; font-size: 0.8em" v-html='msg'></div>
          </v-col>
        </v-row>
        <br/>
        <v-divider></v-divider>
    
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-row>
            <v-col cols="6" class="d-flex align-center justify-end">
              <v-btn rounded class="light-green lighten-3" dark @click="no()"> 同意しない </v-btn>
            </v-col>
            <v-col cols="6" class="d-flex align-center justify-center">
              <v-btn rounded class="light-green lighten-3" dark @click="yes()"> 同意する </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: ["msg", "isOpen", "doYes", "doNo","propDialogWidth", "propDialogTitle"],
  data() {
    return {
      infoDialog: false,
    };
  },
  watch: {
    isOpen: function (val) {
      this.infoDialog = val;
    },
  },
  computed: {
    dialogWidth() {
      return this.propDialogWidth;
    },
    dialogTitle() {
      return this.propDialogTitle;
    },
  },
  updated() {
    const elements = document.getElementsByClassName('v-dialog--active');
    if (!elements || !elements.length) {
      // 要素が取得できなかった場合は終了
      return;
    }
    elements[0].scrollTop = 0;
  },
  methods: {
    yes() {
      this.doYes();
      this.infoDialog = false;
    },
    no() {
      this.doNo();
      this.dialog = false;
    },
  },
};
</script>